export enum AuthError {
  MESSAGE = 'show_message',
  NEXT_PAGE = 'next_flowpage',
  NEXT_PAGE_LOSER = 'next_flowpage_loser'
}
export enum AuthSuccess {
  NEXT_PAGE = 'next_flowpage',
  NEXT_PAGE_WINNER = 'next_flowpage_winner'
}
